export const FEEDBACK_EVENT_NAME = 'developer-docs-feedback-button'
